import { useMemo } from 'react';
import { formatCurrency } from '~/utils';
import {numberFormat} from "../../../utils";
import '../style/SuggestMoney.scss';

/**
 * Vietnamese currency denominations
 */
const DENOMINATIONS = [1000, 2000, 5000, 10000, 20000, 50000, 100000, 500000, 1000000];

/**
 * Generate money suggestions based on required amount
 * @param {number} requiredAmount - Amount customer needs to pay
 * @returns {number[]} Array of suggested amounts
 */
const generateMoneySuggestions = (requiredAmount) =>
{
    if (!requiredAmount || requiredAmount <= 0)
    {
        return DENOMINATIONS.slice(0, 6); // Return first 6 denominations
    }

    const suggestions = new Set();

    // Find closest denomination >= required amount
    const closestDenom = DENOMINATIONS.find(d => d >= requiredAmount);

    if (closestDenom)
    {
        suggestions.add(closestDenom);
    }

    // Add nearby denominations
    const baseIndex = DENOMINATIONS.findIndex(d => d >= requiredAmount);

    if (baseIndex !== -1) {
        // Add next 3 denominations after closest
        for (let i = 0; i < 3 && baseIndex + i < DENOMINATIONS.length; i++) {
            suggestions.add(DENOMINATIONS[baseIndex + i]);
        }
    }

    // Add some round amounts
    const roundAmount = Math.ceil(requiredAmount / 50000) * 50000;
    if (roundAmount >= requiredAmount && !suggestions.has(roundAmount)) {
        suggestions.add(roundAmount);
    }

    const roundAmount100k = Math.ceil(requiredAmount / 100000) * 100000;

    if (roundAmount100k >= requiredAmount && !suggestions.has(roundAmount100k)) {
        suggestions.add(roundAmount100k);
    }

    const roundAmount500k = Math.ceil(requiredAmount / 500000) * 500000;

    if (roundAmount500k >= requiredAmount && !suggestions.has(roundAmount500k))
    {
        suggestions.add(roundAmount500k);
    }

    // Sort and return
    return Array.from(suggestions).sort((a, b) => a - b);
};

const SuggestMoney = ({ requiredAmount, onSelect }) => {
    const suggestions = useMemo(
        () => generateMoneySuggestions(requiredAmount),
        [requiredAmount]
    );

    if (!suggestions || suggestions.length === 0) {
        return null;
    }

    return (
        <div className="suggest-money">
            <div className="suggest-money-items">
                {suggestions.map((amount, index) => (
                    <button
                        key={index}
                        className="suggest-money-btn"
                        onClick={() => onSelect(amount)}
                        title={formatCurrency(amount)}
                    >
                        {numberFormat((amount >= 1000000)
                            ? (amount).toFixed(0)
                            : amount >= 100000
                            ? (amount).toFixed(0)
                            : (amount).toFixed(1))
                        }
                    </button>
                ))}
            </div>
        </div>
    );
};

export default SuggestMoney;
